import { SAVE_BROKERS_LIST } from '../../util/actionTypes';

const initialState = { list: [], isLoading: true };

const brokersReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_BROKERS_LIST:
            return { ...state, list: Array.isArray(action.payload) ? action.payload : [], isLoading: false };
        default:
            return state;
    }
};

export default brokersReducer;


